import { useModal } from 'shared/hooks'

export const useModals = () => {
	const {
		isOpen: isDeleteModalOpen,
		openModal: openDeleteModal,
		closeModal: closeDeleteModal
	} = useModal()
	const {
		isOpen: isExportModalOpen,
		openModal: openExportModal,
		closeModal: closeExportModal
	} = useModal()
	const {
		isOpen: isBulkPayoutModalOpen,
		openModal: openBulkPayoutModal,
		closeModal: closeBulkPayoutModal
	} = useModal()
	const {
		isOpen: isFormatModalOpen,
		openModal: openFormatModal,
		closeModal: closeFormatModal
	} = useModal()
	const {
		isOpen: isPayoutModalOpen,
		openModal: openPayoutModalOpen,
		closeModal: closePayoutModal
	} = useModal()
	const {
		isOpen: isBulkPayoutReminderEmailOpen,
		openModal: openBulkPayoutReminderEmailModal,
		closeModal: closeBulkPayoutReminderEmailModal
	} = useModal()

	return {
		isDeleteModalOpen,
		openDeleteModal,
		closeDeleteModal,
		isExportModalOpen,
		openExportModal,
		closeExportModal,
		isBulkPayoutModalOpen,
		openBulkPayoutModal,
		closeBulkPayoutModal,
		isFormatModalOpen,
		openFormatModal,
		closeFormatModal,
		isPayoutModalOpen,
		openPayoutModalOpen,
		closePayoutModal,
		isBulkPayoutReminderEmailOpen,
		openBulkPayoutReminderEmailModal,
		closeBulkPayoutReminderEmailModal
	}
}
